import { PermissionCode } from "@/constants/permissions";
import { AppRoutes } from "@/constants/routes";
import { Permiso } from "@/pages/role-asignation/schema/role-assignation.schema";
import { Flex, Link } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

interface Props {
  permissions: Permiso[];
}

export const SuppliesView = ({ permissions }: Props) => {
  const navigate = useNavigate();
  const hasAccess = (codigo: string) =>
    permissions?.some((p) => p.codigo === codigo && p.tipoPermiso === "R");

  const canUseFertSlotsReq = hasAccess(PermissionCode.FERT_SLOTS_REQ);
  

  return (
    <Flex flexDir="column" paddingX={2} paddingY={1} gap="10px">
      {canUseFertSlotsReq && (
        <Link variant="plain" onClick={() => navigate(AppRoutes.FERT_SLOTS_REQ)}>
          Cupos de fertilizante
        </Link>
      )}

    </Flex>
  );
};
